import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button, Card, Col, Container, Form, Image, Modal, Row } from 'react-bootstrap';
import { CreateClinicPageStyled } from './CreateClinicPageStyled';

import logo from '../../images/logo_branco.png';
import { EstadosBrasil } from '../../../main/constant/UfConstant';

import { FaEye } from 'react-icons/fa6';
import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft } from 'react-icons/fa';
import { IoLocationOutline } from 'react-icons/io5';
import { PiIdentificationCard } from 'react-icons/pi';
import { AiOutlineFileProtect } from 'react-icons/ai';
import { IoPersonCircleOutline } from 'react-icons/io5';
import { aceiteTermoType, InputsAddClinic, PropsAddClinic, tipoClinicaType } from './CreateClinicPageType';
import AlertComponent from '../../component/alert/AlertComponent';
import { maskUtils } from '../../../main/helper/maskHelper';

/**
 * CreateClinicPage
 * @param createClinic
 * @constructor
 */
const CreateClinicPage: React.FC<PropsAddClinic> = ({ addClinic, comeBack, getAddress, address }: PropsAddClinic) => {
  /** useForm */
  const {
    register,
    getValues,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<InputsAddClinic>();

  /**
   * mostra modal
   */
  const [show, setShow] = useState(false);

  /**
   * handleClose - fecha modal
   */
  const handleClose = () => setShow(false);

  /**
   * handleShow - abre modal
   */
  const handleShow = () => setShow(true);

  /**
   * handleAddClinic
   */
  const handleAddClinic = async () => {
    const model = {
      id: getValues('id') ?? '',
      name: getValues('name') ?? '',
      status: getValues('status') ?? '',
      tradeName: getValues('tradeName') ?? '',
      accountType: clinicaTipo,
      document_CNPJ: clinicaTipo === 'J' ? getValues('document_CNPJ') : '',
      document_CPF: clinicaTipo === 'F' ? getValues('document_CPF') : '',
      contact_Phone: getValues('contact_Phone') ?? '',
      contact_Email: getValues('contact_Email') ?? '',
      address_ZipCode: getValues('address_ZipCode') ?? '',
      address_Street: getValues('address_Street') ?? '',
      address_Number: getValues('address_Number') ?? '',
      address_Complement: getValues('address_Complement') ?? '',
      address_Neighborhood: getValues('address_Neighborhood') ?? '',
      address_City: getValues('address_City') ?? '',
      address_State: getValues('address_State') ?? '',
      address_Country: getValues('address_Country') ?? '',
      responsible_Name: getValues('responsible_Name') ?? '',
      responsible_Email: getValues('responsible_Email') ?? '',
      responsible_Document_CRO: getValues('responsible_Document_CRO') ?? '',
      responsible_Document_RG: getValues('responsible_Document_RG') ?? '',
      responsible_Document_RG_IssuingAuthority: getValues('responsible_Document_RG_IssuingAuthority') ?? '',
      setup_NumberOfChairs: getValues('setup_NumberOfChairs') ?? '',
      setup_DentistAdmin: getValues('setup_DentistAdmin') ?? '',
      setup_StandardAppointmentTime: getValues('setup_StandardAppointmentTime') ?? '',
      setup_WeeklyWorkingHours: getValues('setup_WeeklyWorkingHours') ?? '',
      setup_WeekDays: getValues('setup_WeekDays') ?? '',
    };

    await addClinic(model);
  };

  const [clinicaTipo, setClinicaTipo] = useState<tipoClinicaType>('J');
  const [aceiteTermos, setAceiteTermos] = useState<aceiteTermoType>('N');

  /**
   * handleCepChange - busca o endereco pelo cep
   * @param cep
   */
  const handleCepChange = async (cep: string) => {
    const cepFormatado = maskUtils.cep(cep);
    if (cepFormatado.length === 9) {
      await getAddress(cepFormatado);
    }
  };

  /**
   * inicio
   */
  useEffect(() => {
    if (address !== null) {
      setValue('address_Street', address.street);
      setValue('address_Neighborhood', address.neighborhood);
      setValue('address_City', address.city);
      setValue('address_State', address.state);
    }
  }, [address]);

  return (
    <CreateClinicPageStyled>
      <AlertComponent />
      <Container className="container-header">
        <div className="imagen">
          <Image src={logo} width={200} />
        </div>
      </Container>
      <Container className="container-field">
        <Form onSubmit={handleSubmit(handleAddClinic)}>
          <div style={{ paddingBottom: '5%' }}>
            <div>
              <div className="title">
                <PiIdentificationCard />
                <h6>Clínica</h6>
              </div>
              <div>
                <Row className="row-field" style={{ paddingBottom: '5%' }}>
                  <Col sm={12} md={3}>
                    <Form.Group>
                      <Form.Select
                        onChange={(e) => {
                          setClinicaTipo(e.target.value as tipoClinicaType);
                        }}>
                        <option value="J">Jurídica</option>
                        <option value="F">Fisica</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={9}>
                    <Button size="sm" className="btn-salvar-clinica" style={{ float: 'right' }} type="submit" disabled={aceiteTermos === 'N'}>
                      <TfiSave width={30} style={{ paddingRight: '5px' }} />
                      Salvar
                    </Button>
                    <Button
                      size="sm"
                      className="btn-salvar-clinica"
                      variant="outline-primary"
                      style={{ float: 'right', marginRight: '5px' }}
                      onClick={comeBack}>
                      <FaArrowLeft width={30} style={{ paddingRight: '5px' }} />
                      Voltar
                    </Button>
                  </Col>
                </Row>

                {clinicaTipo === 'J' && (
                  <>
                    <Row className="row-field">
                      <Col sm={12} md={4}>
                        <Form.Label>Nome da clínica</Form.Label>
                        <Form.Control placeholder="Nome da clínica" {...register('name', { required: 'campo obrigatório' })} />
                        {errors.name && <span className="text-danger">{errors.name.message}</span>}
                      </Col>
                      <Col sm={12} md={4}>
                        <Form.Label>Nome fantasia</Form.Label>
                        <Form.Control placeholder="Nome fantasia" {...register('tradeName', { required: 'campo obrigatório' })} />
                        {errors.tradeName && <span className="text-danger">{errors.tradeName.message}</span>}
                      </Col>
                      <Col sm={12} md={4}>
                        <Form.Label>CNPJ</Form.Label>
                        <Controller
                          control={control}
                          name="document_CNPJ"
                          rules={{ required: 'campo obrigatório' }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="CNPJ" onChange={(e) => field.onChange(maskUtils.cnpj(e.target.value))} />
                          )}
                        />
                        {errors.document_CNPJ && <span className="text-danger">{errors.document_CNPJ.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col sm={12} md={6}>
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control placeholder="E-mail" {...register('contact_Email', { required: 'campo obrigatório' })} />
                        {errors.contact_Email && <span className="text-danger">{errors.contact_Email.message}</span>}
                      </Col>
                      <Col sm={12} md={6}>
                        <Form.Label>Telefone</Form.Label>
                        <Controller
                          control={control}
                          name="contact_Phone"
                          rules={{ required: 'campo obrigatório' }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Telefone" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                        {errors.contact_Phone && <span className="text-danger">{errors.contact_Phone.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>CRO do Responsável Técnico</Form.Label>
                        <Form.Control placeholder="CRO do Responsável Técnico" {...register('responsible_Document_CRO', { required: 'campo obrigatório' })} />
                        {errors.responsible_Document_CRO && <span className="text-danger">{errors.responsible_Document_CRO.message}</span>}
                      </Col>
                    </Row>
                  </>
                )}

                {clinicaTipo === 'F' && (
                  <>
                    <Row className="row-field">
                      <Col>
                        <Form.Label>Nome</Form.Label>
                        <Form.Control placeholder="Nome" {...register('name', { required: 'campo obrigatório' })} />
                        {errors.name && <span className="text-danger">{errors.name.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>CPF</Form.Label>
                        <Controller
                          control={control}
                          name="document_CPF"
                          rules={{ required: 'campo obrigatório' }}
                          render={({ field }) => <Form.Control {...field} placeholder="CPF" onChange={(e) => field.onChange(maskUtils.cpf(e.target.value))} />}
                        />
                        {errors.document_CPF && <span className="text-danger">{errors.document_CPF.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col>
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control placeholder="E-mail" {...register('contact_Email', { required: 'campo obrigatório' })} />
                        {errors.contact_Email && <span className="text-danger">{errors.contact_Email.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>Telefone</Form.Label>
                        <Controller
                          control={control}
                          name="contact_Phone"
                          rules={{ required: 'campo obrigatório' }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Telefone" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                        {errors.contact_Phone && <span className="text-danger">{errors.contact_Phone.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>CRO do Responsável</Form.Label>
                        <Form.Control placeholder="CRO do Responsável" {...register('responsible_Document_CRO', { required: 'campo obrigatório' })} />
                        {errors.responsible_Document_CRO && <span className="text-danger">{errors.responsible_Document_CRO.message}</span>}
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
            <div>
              <div className="title">
                <IoLocationOutline />
                <h6>Endereço</h6>
              </div>
              <div>
                <Row className="row-field">
                  <Col sm={3}>
                    <Form.Label>Cep</Form.Label>
                    <Controller
                      control={control}
                      name="address_ZipCode"
                      rules={{ required: 'campo obrigatório' }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          placeholder="Cep"
                          onChange={(e) => {
                            const cepComMascara = maskUtils.cep(e.target.value);
                            field.onChange(cepComMascara);
                            handleCepChange(cepComMascara);
                          }}
                        />
                      )}
                    />
                    {errors.address_ZipCode && <span className="text-danger">{errors.address_ZipCode.message}</span>}
                  </Col>
                  <Col>
                    <Form.Label>Endereço</Form.Label>
                    <Form.Control placeholder="Endereço" {...register('address_Street', { required: 'campo obrigatório' })} />
                    {errors.address_Street && <span className="text-danger">{errors.address_Street.message}</span>}
                  </Col>
                </Row>
                <Row className="row-field">
                  <Col>
                    <Form.Label>Número</Form.Label>
                    <Form.Control placeholder="Número" {...register('address_Number', { required: 'campo obrigatório' })} />
                    {errors.address_Number && <span className="text-danger">{errors.address_Number.message}</span>}
                  </Col>
                  <Col>
                    <Form.Label>Complemento</Form.Label>
                    <Form.Control placeholder="Complemento" {...register('address_Complement')} />
                  </Col>
                  <Col>
                    <Form.Label>Bairro</Form.Label>
                    <Form.Control placeholder="Bairro" {...register('address_Neighborhood', { required: 'campo obrigatório' })} />
                    {errors.address_Neighborhood && <span className="text-danger">{errors.address_Neighborhood.message}</span>}
                  </Col>
                  <Col>
                    <Form.Label>Cidade</Form.Label>
                    <Form.Control placeholder="Cidade" {...register('address_City', { required: 'campo obrigatório' })} />
                    {errors.address_City && <span className="text-danger">{errors.address_City.message}</span>}
                  </Col>
                  <Col>
                    <Form.Label>Estado</Form.Label>
                    <Form.Select aria-label="UF" {...register('address_State', { required: 'campo obrigatório' })}>
                      <option>Selecione a UF</option>
                      {EstadosBrasil.map((item) => (
                        <option key={item.sigla} value={item.sigla}>
                          {item.nome}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.address_State && <span className="text-danger">{errors.address_State.message}</span>}
                  </Col>
                </Row>
              </div>
            </div>
            {clinicaTipo === 'J' && (
              <div>
                <div className="title">
                  <IoPersonCircleOutline />
                  <h6>Gestor administrador da clínica</h6>
                </div>
                <div>
                  <Row className="row-field">
                    <Col>
                      <Form.Label>Nome</Form.Label>
                      <Form.Control placeholder="Nome" {...register('responsible_Name', { required: 'campo obrigatório' })} />
                      {errors.responsible_Name && <span className="text-danger">{errors.responsible_Name.message}</span>}
                    </Col>
                  </Row>
                  <Row className="row-field">
                    <Col>
                      <Form.Label>E-mail</Form.Label>
                      <Form.Control placeholder="E-mail" {...register('responsible_Email', { required: 'campo obrigatório' })} />
                      {errors.responsible_Email && <span className="text-danger">{errors.responsible_Email.message}</span>}
                    </Col>
                    <Col>
                      <Form.Label>Celular</Form.Label>
                      <Controller
                        control={control}
                        name="responsible_Document_RG"
                        rules={{ required: 'campo obrigatório' }}
                        render={({ field }) => (
                          <Form.Control {...field} placeholder="Celular" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                        )}
                      />
                      {errors.responsible_Document_RG && <span className="text-danger">{errors.responsible_Document_RG.message}</span>}
                    </Col>
                    <Col>
                      <Form.Label>Quantidade de Cadeiras</Form.Label>
                      <Controller
                        control={control}
                        name="setup_NumberOfChairs"
                        rules={{ required: 'campo obrigatório' }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            placeholder="Quantidade de Cadeiras"
                            onChange={(e) => field.onChange(maskUtils.somenteNumeros(e.target.value))}
                          />
                        )}
                      />
                      {errors.setup_NumberOfChairs && <span className="text-danger">{errors.setup_NumberOfChairs.message}</span>}
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            <div>
              <div className="title d-flex align-items-center">
                <AiOutlineFileProtect style={{ marginRight: '8px' }} />
                <h6 className="mb-0">Termos e condições de uso</h6>
              </div>
              <div>
                <Row className="row-field mt-3">
                  <Col xs={12} sm={6} md={4} className="d-flex justify-content-center mb-2 mb-sm-0">
                    <Button className="btn-salvar-clinica d-flex align-items-center" onClick={handleShow}>
                      <FaEye size={18} style={{ marginRight: '5px' }} />
                      Ler os termos
                    </Button>
                  </Col>
                  <Col xs={12} sm={6} md={8} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                    <Form.Check
                      type="checkbox"
                      label="Li e concordo"
                      checked={aceiteTermos === 'S'}
                      onChange={(e) => setAceiteTermos(e.target.checked ? 'S' : 'N')}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Form>
        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Termos de uso</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container fluid className="table-especialidade-page">
              <Card>
                <Card.Body>
                  Mussum Ipsum, cacilds vidis litro abertis. Morbi viverra placerat justo, vel pharetra turpis. Mais vale um bebadis conhecidiss, que um
                  alcoolatra anonimis. Diuretics paradis num copo é motivis de denguis. Si u mundo tá muito paradis? Toma um mé que o mundo vai girarzis!
                  Admodum accumsan disputationi eu sit. Vide electram sadipscing et per. Viva Forevis aptent taciti sociosqu ad litora torquent. Vehicula non.
                  Ut sed ex eros. Vivamus sit amet nibh non tellus tristique interdum. Interagi no mé, cursus quis, vehicula ac nisi. Eu nunca mais boto a boca
                  num copo de cachaça, agora eu só uso canudis! Aenean aliquam molestie leo, vitae iaculis nisl. Mais vale um bebadis conhecidiss, que um
                  alcoolatra anonimis. Pra lá, depois divoltis porris, paradis. Interagi no mé, cursus quis, vehicula ac nisi. Si num tem leite então bota uma
                  pinga aí cumpadi! Admodum accumsan disputationi eu sit. Vide electram sadipscing et per. Quem num gosta di mé, boa gentis num é. Copo furadis
                  é disculpa de bebadis, arcu quam euismod magna. Interessantiss quisso pudia ce receita de bolis, mais bolis eu num gostis. Si u mundo tá muito
                  paradis? Toma um mé que o mundo vai girarzis! Tudo mundo vê os porris que eu tomo, mas ninguém vê os tombis que eu levo! Paisis, filhis,
                  espiritis santis. Bota 1 metro de cachacis aí pra viagem! A ordem dos tratores não altera o pão duris. Nullam volutpat risus nec leo commodo,
                  ut interdum diam laoreet. Sed non consequat odio. Suco de cevadiss deixa as pessoas mais interessantis. Em pé sem cair, deitado sem dormir,
                  sentado sem cochilar e fazendo pose. In elementis mé pra quem é amistosis quis leo. Detraxit consequat et quo num tendi nada. Atirei o pau no
                  gatis, per gatis num morreus. Pellentesque nec nulla ligula. Donec gravida turpis a vulputate ultricies. Interagi no mé, cursus quis, vehicula
                  ac nisi. Nulla id gravida magna, ut semper sapien. Tá deprimidis, eu conheço uma cachacis que pode alegrar sua vidis. Eu nunca mais boto a
                  boca num copo de cachaça, agora eu só uso canudis! Interessantiss quisso pudia ce receita de bolis, mais bolis eu num gostis. Quem manda na
                  minha terra sou euzis! Diuretics paradis num copo é motivis de denguis. Viva Forevis aptent taciti sociosqu ad litora torquent. Interagi no
                  mé, cursus quis, vehicula ac nisi. Não sou faixa preta cumpadi, sou preto inteiris, inteiris.
                </Card.Body>
              </Card>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button size="sm" variant="secondary" onClick={handleClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </CreateClinicPageStyled>
  );
};

export default CreateClinicPage;
